import { render, staticRenderFns } from "./pjBiddingNotice.vue?vue&type=template&id=72475eb4&scoped=true&"
import script from "./pjBiddingNotice.vue?vue&type=script&lang=js&"
export * from "./pjBiddingNotice.vue?vue&type=script&lang=js&"
import style0 from "./pjBiddingNotice.vue?vue&type=style&index=0&id=72475eb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72475eb4",
  null
  
)

export default component.exports